import React, { useEffect, useRef, useState } from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link } from "react-router-dom";
import "./RightSideBar.css";

const RightSideBar = (props) => {
  const { componentLayout, componentData, isFooter = true } = props;
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);
  const [showFooter, setShowFooter] = useState(true);

  // Handle outside click to close sidebar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!sidebarRef.current) return;

      const isClickInsideSidebar = sidebarRef.current.contains(event.target);
      const isMuiComponent = event.target.closest(
        ".sidebar, .cke_dialog, .MuiPopover-root, .MuiMenu-root, .MuiPaper-root, .twoduplicatecustomModalDiv, .duplicatecustomModalDiv, .cke_notifications_area, .customModalDiv, .MuiPopper-root, .MuiAutocomplete-popper, .loaderSection, .MuiPickersPopper-root",
      );

      if (!isClickInsideSidebar && !isMuiComponent) {
        props.onReceiveProps(false, "close");
        document.body.classList.remove("autocomplete-dropdown-open");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  // Function to check height
  const checkHeight = () => {
    if (!sidebarRef.current || !contentRef.current || !footerRef.current)
      return;

    const sidebarHeight = sidebarRef.current.clientHeight;
    const contentHeight = contentRef.current.clientHeight;
    const footerHeight = footerRef.current.clientHeight;

    // Hide footer if content + footer exceeds sidebar height
    setShowFooter(contentHeight + footerHeight <= sidebarHeight);
  };

  // 🔹 Track changes using MutationObserver
  useEffect(() => {
    if (!sidebarRef.current) return;

    const observer = new MutationObserver(() => {
      checkHeight(); // Recalculate height on content change
    });

    observer.observe(contentRef.current, { childList: true, subtree: true });

    return () => observer.disconnect(); // Cleanup observer on unmount
  }, []);

  return (
    <section className="sidebarBg">
      <div className="sidebar" ref={sidebarRef}>
        <div className="headertext">
          <div className="header-title-container">
            <p
              className={
                componentLayout.pageName === "vendorportal" ? "heading1" : ""
              }
              style={componentLayout.titleColor ? { color: componentLayout.titleColor } : undefined}
            >
              {componentLayout.title}
            </p>
            <div id="sidebar-header-portal" />
          </div>
          {componentLayout.navigateTo ? (
            <Link to={componentLayout.navigateTo} target="_blank" type="button">
              <OpenInNewIcon />
            </Link>
          ) : (
            " "
          )}
          <img
            src={process.env.PUBLIC_URL + "/assests/img/close.svg"}
            alt=""
            className="closeicon"
            onClick={() => props.onReceiveProps(false, "close")}
          />
        </div>

        <div className="contentSection pannelContent" ref={contentRef}>
          {componentLayout.description?.length > 0 && (
            <h6>{componentLayout.description}</h6>
          )}
          <article>{componentData}</article>
        </div>
        {isFooter && (
          <footer
            className="footerimg"
            style={{ visibility: !showFooter ? "hidden" : "visible" }}
            ref={footerRef}
          >
            {props.footerImg ? props.footerImg : ""}
          </footer>
        )}
      </div>
    </section>
  );
};

export default RightSideBar;
